import {
  WEBAPP_CB2_DEFAULT_PAGE_ROUTES,
  WEBAPP_DEFAULT_PAGE_ROUTES,
} from '@front-platform/content-builder';
import type { WebappDefaultPageRoute } from '@front-platform/content-builder';

import { IPageConfig } from '@core/models/marketplace.model';

function toPageConfig(route: WebappDefaultPageRoute): IPageConfig {
  return {
    path: route.path,
    ...(route.block ? { block: route.block } : {}),
    ...(route.guards ? { guards: [...route.guards] } : {}),
    ...(route.redirect_to ? { redirect_to: route.redirect_to } : {}),
    ...(route.children ? { children: route.children.map(toPageConfig) } : {}),
  };
}

export const DEFAULT_PAGES: IPageConfig[] = WEBAPP_DEFAULT_PAGE_ROUTES.map(toPageConfig);

/** CB2-only fallback. Same merge as v1, without the v1 catalogue. */
export const CB2_DEFAULT_PAGES: IPageConfig[] = WEBAPP_CB2_DEFAULT_PAGE_ROUTES.map(toPageConfig);
